import { Spinner } from '@alkem/react-ui-spinner';
import classNames from 'classnames';
import { Component, MouseEvent, ReactNode } from 'react';
import './react-ui-button.scss';

type ButtonMouseEvent = MouseEvent<any>;

export interface ButtonProps {
  children?: ReactNode;
  content?: ReactNode;
  disabled?: boolean;
  displaySpinner?: boolean;
  className?: string;
  href?: string;
  id?: string;
  link?: boolean;
  onClick?: (mouseEvent: ButtonMouseEvent, props: ButtonProps) => void | any;
  plain?: boolean;
  primary?: boolean;
  secondary?: boolean;
  small?: boolean;
  success?: boolean;
  target?: string;
  type?: 'button' | 'submit' | 'reset';
  warning?: boolean;
  white?: boolean;
  testid?: string;
}

class Button extends Component<ButtonProps> {
  public static demoProps = [
    { content: 'Primary', primary: true },
    { content: 'Secondary', secondary: true },
    { content: 'Warning', warning: true },
    { content: 'Link', link: true },
    { content: 'href', href: 'http://google.com' },
    { content: 'Success', success: true },
    { content: 'Success', primary: true, disabled: true },
    { content: 'Loading', primary: true, displaySpinner: true },
  ];

  public static defaultProps = {
    disabled: false,
    displaySpinner: false,
    link: false,
    plain: false,
    primary: false,
    secondary: false,
    small: false,
    success: false,
    type: 'button',
    warning: false,
    white: false,
  };

  private onClick = (event: ButtonMouseEvent) => {
    const { onClick, disabled } = this.props;
    if (onClick && !disabled) {
      onClick(event, Object.assign({}, this.props));
    }
  };

  public render() {
    const {
      disabled,
      displaySpinner,
      href,
      id,
      primary,
      secondary,
      success,
      target,
      testid,
      type,
      warning,
      white,
    } = this.props;
    const className = classNames(
      'Button',
      'btn',
      {
        'btn-link': this.props.link,
        'btn-primary': this.props.primary,
        'btn-secondary': this.props.secondary,
        'btn-small': this.props.small,
        'btn-success': this.props.success,
        'btn-warning': this.props.warning,
        'btn-white': this.props.white,
        disabled: this.props.disabled,
        plain: this.props.plain,
      },
      this.props.className
    );
    const content = this.props.children || this.props.content;

    if (href) {
      return (
        <a
          className={className}
          href={href}
          target={target}
          onClick={this.onClick}
          data-disabled={disabled}
          data-testid={testid}
        >
          {content}
        </a>
      );
    }

    return (
      <button
        id={id}
        // eslint-disable-next-line react/button-has-type
        type={type}
        className={className}
        onClick={this.onClick}
        disabled={disabled}
        data-testid={testid}
      >
        <span className="Button__content">
          {content}
          <Spinner
            className="Button__spinner"
            loading={displaySpinner}
            primary={primary}
            secondary={secondary}
            small
            success={success}
            warning={warning}
            white={white}
          />
        </span>
      </button>
    );
  }
}

export default Button;
